import { useRef } from 'react';
import { FormChallenge, type ChallengeHandle } from '@/components/forms/FormChallenge';

export function useFormChallenge(action: 'contact' | 'employer' | 'qa-engineer' | 'booking') {
  const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY?.trim();
  const ref = useRef<ChallengeHandle>(null);
  return {
    challenge: <FormChallenge ref={ref} action={action} />,
    getToken: () => {
      if (siteKey && !ref.current) throw new Error('Please wait for the security check to load.');
      return ref.current?.getToken();
    },
    reset: () => ref.current?.reset(),
  };
}
